import { render } from "./AdminWorkflowsHome.vue?vue&type=template&id=67f2486d&scoped=true"
import script from "./AdminWorkflowsHome.vue?vue&type=script&lang=js"
export * from "./AdminWorkflowsHome.vue?vue&type=script&lang=js"

import "./AdminWorkflowsHome.vue?vue&type=style&index=0&id=67f2486d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67f2486d"]])

export default __exports__